<!--Main data-->
<div class="MainData">
	<div class="MainGrid">
		<label>Order By:</label>
		<select [disabled]="IsLoading() == true" class="form-control" name="OrderByOption" [(ngModel)]="OrderByOption">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstOrderByOption" [ngValue]="o.ID">
				{{ o.Desc }}
			</option>
		</select>

		<label>Logo:</label>
		<select [disabled]="IsLoading() == true" class="form-control" name="ImageLogo" [(ngModel)]="ImageLogo">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstImageLogo" [ngValue]="o.ImageLibraryID">
				{{ o.LogoDesc }}
			</option>
		</select>

		<label>File Type:</label>
		<select [disabled]="IsLoading() == true" class="form-control" name="OutputTypeID" [(ngModel)]="OutputTypeID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of OutputTypeList" [ngValue]="o.ID">
				{{ o.Desc }}
			</option>
		</select>
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onContinue()">Continue</button>
	<button class="btn btn-warning" (click)="onClose()">Cancel</button>
</div>
